export { default as withAdditionalFieldsComponent } from './with-additional-fields-component';
